import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dummyData from "../../../database/programs.json";
import adapter from "../../programs/adapter";
import * as config from "./config";
import { generateCoreExtraReducers, generateSliceCore } from "../../core/tools";
import apiService from "../../api/service";
const { NAME } = config;

const core = generateSliceCore(config);
const app = {
  initialState: {
    _payload: null,
    status: "idle",
    error: "",
    data: dummyData,
    data_options: [],
    data_map: [],
    data_featured: [],
  },
  action: {
    fetchPrograms: createAsyncThunk(
      `${NAME}/fetchPrograms`,
      async (options) => {
        const data = await apiService.get(NAME, options);
        return data;
      }
    ),
    fetchByIdPrograms: createAsyncThunk(
      `${NAME}/fetchPrograms`,
      async (options) => {
        const data = await apiService.getFromPath(`a1/organizations/${options.id}/programs/`, options);
        return data;
      }
    ),
    fetchFeaturedPrograms: createAsyncThunk(
      `${NAME}/fetchFeaturedPrograms`,
      async (options) => {
        const data = await apiService.get("programs_featured", options);
        return data;
      }
    ),
  },
};

/** Action - Thunks */
export const { setQuery, setCurrentPage, setSorter } = core.action;
export const { fetchPrograms, fetchByIdPrograms, fetchFeaturedPrograms } = app.action;

/** Reducer - Extra Reducers */
const coreExtraReducers = generateCoreExtraReducers(core.action);

/** Slice */
export const organizationProgramsSlice = createSlice({
  name: NAME,
  initialState: {
    ...core.initialState,
    ...app.initialState,
  },
  reducers: {
    setStatus(state, action) {
      state.status = action.payload;
    },
    setPageItems(state, action) {
      state.pageItems = action.payload;
    },
  },
  extraReducers: {
    ...coreExtraReducers,

    [fetchPrograms.pending]: (state) => {
      state.status = "loading";
    },
    [fetchPrograms.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const { results, count } = action.payload;

      state.data = adapter.responseBodyToRender(results);
      state.data_options = adapter.responseBodyToOptions(results);
      state.data_map = adapter.responseBodyToMap(results);
      state.totalItems = count;
    },
    [fetchPrograms.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [fetchByIdPrograms.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const { results, count } = action.payload;

      state.data = adapter.responseBodyToRender(results);
      state.data_options = adapter.responseBodyToOptions(results);
      state.data_map = adapter.responseBodyToMap(results);
      state.totalItems = count;
    },

    [fetchFeaturedPrograms.fulfilled]: (state, action) => {
      state.data_featured_payload = action.payload;
      state.data_featured = adapter.responseBodyToRender(action.payload);
    },
  },
});

export const { setStatus, setPageItems } = organizationProgramsSlice.actions;

export const organizationProgramsActions = {
  ...organizationProgramsSlice.actions,
  ...core.action,
  ...app.action,
};

export default organizationProgramsSlice.reducer;
